export const env = {
    envName: "DEV",
    production: false,
    test: false,
    applicationName: "chat-npp",
    defaultLanguage: "en",
    baseURL: process.env.REACT_APP_BASE_URL,
    cryptoKey: process.env.REACT_APP_AUTH_TOKEN,
} 